import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TooltipMUI6 from 'src/components/TooltipMUI6';

function TooltipMUI6Container({
  children,
  disabled = true,
  tooltipProps = {},
  containerProps = {},
}) {
  const containerAndChild = (
    <Box
      {...containerProps || {}}
    >
      {children}
    </Box>
  );

  return !disabled ? (
    <TooltipMUI6
      {...tooltipProps || {}}
    >
      {containerAndChild}
    </TooltipMUI6>
  ) : containerAndChild;
}

TooltipMUI6Container.propTypes = {
  disabled: PropTypes.bool,
  tooltipProps: PropTypes.object,
  containerProps: PropTypes.object,
  children: PropTypes.any,
};

export default TooltipMUI6Container;
